import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import DropDown from "./DropDown";
import IconButton from "../IconButton/IconButton";

import { useWhatInputIsLastPointerMouse } from "../../what-input/useWhatInput";

import styles from "../Select/SelectVariantIcon.module.scss";

const DropDownVariantIconButton = ({
  icon,
  disabled,
  active,
  iconTitle,
  iconBordered,
  iconColor,
  showIcon,
  className,
  buttonClassName,
  isPopupCoversButtonByDefault,
  toggleOnMouseOverLeave,
  id,
  style,
  buttonProps,
  popupProps,
  children,
}) => {
  const isLastInputMouse = useWhatInputIsLastPointerMouse();

  // [EGWW-2043]
  const refIdTimerPreventOpenOnClick = useRef();
  const refIsPreventOpenOnClick = useRef(false);
  // ============

  const handleMouseOverButton = () => {
    if (toggleOnMouseOverLeave && isLastInputMouse) {
      refIsPreventOpenOnClick.current = true;

      clearTimeout(refIdTimerPreventOpenOnClick.current);

      refIdTimerPreventOpenOnClick.current = setTimeout(() => {
        refIdTimerPreventOpenOnClick.current = undefined;

        refIsPreventOpenOnClick.current = false;
      }, 750);
    } else {
      refIsPreventOpenOnClick.current = false;
    }
  };

  return (
    <DropDown
      toggleOnClickButton
      isPopupCoversButtonByDefault={isPopupCoversButtonByDefault}
      toggleOnMouseOverLeave={toggleOnMouseOverLeave}
      className={classNames(className, styles["root"])}
      style={style}
      popupProps={popupProps}
      button={({
        show,
        onClick,
      }) => {
        return (
          <IconButton
            bordered={iconBordered}
            showIcon={showIcon}
            id={id}
            active={active || show}
            title={iconTitle}
            icon={icon}
            color={iconColor}
            className={buttonClassName}
            onClick={(...args) => refIsPreventOpenOnClick.current ? undefined : onClick(...args)}
            disabled={disabled}
            onMouseOver={handleMouseOverButton}
            {...buttonProps}
          />
        );
      }}
      body={children}
    />
  );
};

DropDownVariantIconButton.defaultProps = {
  withToggleDelayRestriction: true,
};

DropDownVariantIconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  iconTitle: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  maxHeight: PropTypes.number,
  withRadio: PropTypes.bool,
  toggleOnMouseOverLeave: PropTypes.bool,
  id: PropTypes.string,
};

export default DropDownVariantIconButton;
